export interface ImageCardItem {
  imageUrl: string;
  mobileImageUrl?: string;
  linkUrl?: string;
  altText?: string;
}
